// extracted by mini-css-extract-plugin
export default {"page":"page__d7511864","container":"container__d7511864","content":"content__d7511864"};